import {
  ItemsViewLayout,
  layouts,
} from '@app/components/items-view-layout-switch/ItemsViewLayoutSwitch';
import { createAppStore } from '@app/core/stores';

interface StatusSettingsState {
  view: ItemsViewLayout;
  setView: (view: ItemsViewLayout) => void;
}

/** Maps legacy persisted view values to ItemsViewLayout. */
function migrateView(view: string): ItemsViewLayout {
  switch (view) {
    case 'grid-2':
      return 'gridWide';
    case 'grid-3':
      return 'gridNormal';
    case 'grid-4':
      return 'gridCompact';
    default:
      return layouts.includes(view as ItemsViewLayout) ? (view as ItemsViewLayout) : 'list';
  }
}

/**
 * Zustand store for managing status screen settings.
 * Persists view preference (list / gridWide / gridNormal / gridCompact) across sessions.
 */
export const useStatusSettingsStore = createAppStore<StatusSettingsState>('StatusSettingsStore', {
  persist: {
    name: 'app.statusSettings',
    version: 4,
    migrate: (persistedState: unknown, version: number) => {
      const state = persistedState as { view?: string };
      let view: string = state?.view ?? 'list';
      if (version < 3) {
        if (version < 2 && view === 'grid') {
          view = 'gridNormal';
        } else {
          view = migrateView(view);
        }
      }
      if (version < 4) {
        view = migrateView(view);
      }
      return { ...state, view } as StatusSettingsState;
    },
  },
})((set) => ({
  view: 'list',
  setView: (view) => {
    set({ view });
  },
}));
